import { get } from "lodash"
import createModule from "../createModule"
import view from "./view"
import { Creators } from "./model"
import { getMenuItems } from "./selectors"
import { getCurrentFactors, getTotalRow, getFactorRiskScales, getCategories, getSelectedFactorCategory } from "./selectors/data"
import { MODEL_METADATA_QUERY } from "resources/models"

export default createModule({
  view,
  required: ["account", "modelId", "positionSet", "selectedDate"],
  data: [{
    resource: "analyzeFactorsRisk",
    as: null,
    url: ({ modelId, selectedDate, segment, isActive, base, baseSignature, positionSet, currency, fxHedgeEnabled }) => {
      const { id, type } = positionSet
      return ({
        id: `analyzeFactorsRisk-${modelId}${id}${selectedDate}${JSON.stringify(segment)}${isActive}${baseSignature}${currency}${fxHedgeEnabled}`,
        query: `query ($modelId: String!, $type: PositionSetType, $id: String!, $from: Date!, $to: Date!, $base: [PositionSetInput], $segment: Segment, $horizon: PositiveInt!, $confidence: Float!) {
          model(id: $modelId) {
            simulation(positionSet: {type: $type, id: $id, segment: $segment}, from: $from, to: $to, base: $base, interval: AUTO) {
              risk{
                total
                attribution{
                  summary{
                    factors
                    specific
                  }
                  factors{
                    id
                    value
                  }
                }
              }
              valueAtRisk(tradingDaysHorizon: $horizon, confidence: $confidence){
                total
                attribution{
                  summary {
                    factors
                    specific
                  }
                  factors {
                    id
                    value
                  }
                }
              }
              exposure {
                factors {
                  id
                  currencyExposure
                  net
                }
              }
            }
          }
        }`,
        variables: {
          from: selectedDate,
          to: selectedDate,
          base: isActive ? [base] : undefined,
          modelId,
          id,
          type,
          segment,
          horizon: 252,
          confidence: 84,
        },
      })
    },
  }, {
    resource: "factorCovariances",
    as: null,
    url: ({ modelId, selectedDate, isComposite }) => {
      // Only used in composite screen to calculate VaR %, and factors are not aggregated for now
      if (!isComposite) { return null }
      return ({
        id: `factorCovariances-${modelId}-${selectedDate}`,
        query: `# factorCovariances
          query ($modelId: String!, $selectedDate: Date!) {
            model (id: $modelId) {
              factors {
                id
                covariance (on: $selectedDate) {
                  factors { id, annualizedPercentSquared }
                }
              }
            }
          }`,
        variables: {
          modelId,
          selectedDate,
        },
      })
    },
  },
  MODEL_METADATA_QUERY,
  ],
  actions: {
    ...Creators,
  },
  mapStateToProps: (state, props) => ({
    ...get(state, "modules.analyzeFactorsRisk"),
    selectedFactorCategory: getSelectedFactorCategory(state, props),
    menuItems: getMenuItems(state, props),
    categories: getCategories(state, props),
    factors: getCurrentFactors(state, props),
    totalRow: getTotalRow(state, props),
    scales: getFactorRiskScales(state, props),
  }),
})
